// change header color on scroll
$(window).scroll(function() {
    var scroll = $(window).scrollTop();
    //>=, not <=
    if (scroll >= 300) {
        //clearHeader, not clearheader - caps H
        $(".header.contrast-on-scroll").addClass("active");
    } else {
        $(".header.contrast-on-scroll").removeClass("active");
    }
});